export default __webpack_public_path__ + "static/media/Category-Multivitamin.724b36a4.jpg";